var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunnelFullIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49996 7.5V14.0667C8.5333 14.3167 8.44996 14.5833 8.2583 14.7583C7.9333 15.0833 7.4083 15.0833 7.0833 14.7583L5.4083 13.0833C5.21663 12.8917 5.1333 12.6333 5.16663 12.3917V7.5H5.14163L0.341629 1.35C0.0582961 0.991667 0.124963 0.466667 0.483296 0.183333C0.64163 0.0666667 0.816629 0 0.999963 0H12.6666C12.85 0 13.025 0.0666667 13.1833 0.183333C13.5416 0.466667 13.6083 0.991667 13.325 1.35L8.52496 7.5H8.49996Z",
    fill: "#DD6FD1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunnelFullIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/funnel-full-icon.e68c150423bfda6613e327c855fbe013.svg";